<template>
    <div class="help-center">
        <a :href="$t('Button.help_center_url')" v-tooltip="{ content: $t('Button.help_center_tooltip'), html: true }" target="_blank" rel="noopener noreferrer">
            <span :class="['icon-help', theme]"></span>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'help-center',
        inject: ['headerTheme'],
        computed: {
            theme () {
                return this.headerTheme()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .help-center {
        position: relative;

        .icon-help {
            border-radius: 100%;
            width: 38px;
            height: 38px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: $lavender;
            line-height: 4px;
            color: $white;
            font-size: 1.4rem;

            &:hover {
                background: $next_indigo;
            }
        }
    }
</style>
